export const isFileFormatAllowed = (filename: string, allowedFileFormats: ReadonlyArray<string>) => {
  const fileFormat = `.${filename.split('.').pop()?.toLowerCase()}`
  return allowedFileFormats.includes(fileFormat)
}

export const isFileListAllowed = (fileList: Iterable<Pick<File, 'name'>>, allowedFileFormats: ReadonlyArray<string>) =>
  [...fileList].every(file => isFileFormatAllowed(file.name, allowedFileFormats))
